import React, { memo } from 'react';
import { Award, Calendar, Users, Zap } from 'lucide-react';
const Services = () => {
  return <section id="servicios" className="py-16 md:py-24 bg-gray-50" data-id="element-290">
      <div className="container mx-auto px-4" data-id="element-291">
        <div className="text-center mb-16" data-id="element-292">
          <h2 className="text-3xl md:text-4xl font-bold text-promred-gray mb-4" data-id="element-293">
            Nuestros Servicios
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-294">
            Ofrecemos servicios para la gestión de eventos, adaptados a las
            necesidades de su empresa.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-295">
          <div className="bg-white p-8 rounded-lg shadow-md hover:shadow-lg transition-shadow" data-id="element-296">
            <div className="w-14 h-14 bg-promred-blue bg-opacity-10 rounded-full flex items-center justify-center mb-6" data-id="element-297">
              <Calendar className="text-promred-blue" size={28} data-id="element-298" />
            </div>
            <h3 className="text-xl font-bold text-promred-gray mb-3" data-id="element-299">
              Gestión de Eventos
            </h3>
            <p className="text-gray-600 mb-4" data-id="element-300">
              Nos encargamos de la operativa y tecnología de sus eventos,
              garantizando una experiencia memorable para todos los asistentes.
            </p>
            <ul className="space-y-2 text-gray-600" data-id="element-301">
              <li className="flex items-start" data-id="element-302">
                <span className="text-promred-blue mr-2" data-id="element-303">•</span>
                Planificación y logística integral
              </li>
              <li className="flex items-start" data-id="element-304">
                <span className="text-promred-blue mr-2" data-id="element-305">•</span>
                Soluciones tecnológicas para eventos
              </li>
              <li className="flex items-start" data-id="element-306">
                <span className="text-promred-blue mr-2" data-id="element-307">•</span>
                Análisis post-evento y medición de resultados
              </li>
            </ul>
          </div>
          <div className="bg-white p-8 rounded-lg shadow-md hover:shadow-lg transition-shadow" data-id="element-308">
            <div className="w-14 h-14 bg-promred-yellow bg-opacity-10 rounded-full flex items-center justify-center mb-6" data-id="element-309">
              <Users className="text-promred-orange" size={28} data-id="element-310" />
            </div>
            <h3 className="text-xl font-bold text-promred-gray mb-3" data-id="element-311">
              Gestión de Relaciones con Clientes
            </h3>
            <p className="text-gray-600 mb-4" data-id="element-312">
              Implementamos estrategias efectivas para fortalecer las relaciones
              con sus clientes y aumentar su satisfacción.
            </p>
            <ul className="space-y-2 text-gray-600" data-id="element-313">
              <li className="flex items-start" data-id="element-314">
                <span className="text-promred-orange mr-2" data-id="element-315">•</span>
                Segmentación y personalización
              </li>
              <li className="flex items-start" data-id="element-316">
                <span className="text-promred-orange mr-2" data-id="element-317">•</span>
                Campañas de comunicación multicanal
              </li>
              <li className="flex items-start" data-id="element-318">
                <span className="text-promred-orange mr-2" data-id="element-319">•</span>
                Medición de satisfacción y feedback
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
};
export default Services;